export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Audio Samenvoegtoestel",
  "Merge Audio": "Audio samenvoegen",
  "Merge multiple audio tracks into one.": "Voeg meerdere audiotracks samen tot één.",
  "Merge New": "Samenvoegen Nieuw",
  "Merge failed": "Samenvoegen mislukt",
  "Fade in": "Fade in",
  "Fade out": "Fade uit",
  "Add tracks": "Sporen toevoegen",
  "Format": "Formaat",
};
